'use client';
import type { StoryOverview } from '~/common/types/story-overview';
import { SensitiveStoryModal } from './sensitive-story-modal';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  story: StoryOverview;
  isSensitiveParam: boolean;
};
export const SensitiveStoryModalContainer = ({
  story,
  isSensitiveParam,
}: Props) => {
  const {
    isShowAlwaysChecked,
    changeAlwaysShowSetting,
    session,
    sensitiveStoryModal,
    onClickOk,
    onClickCancel,
  } = useLocalHooks(story, isSensitiveParam);

  return (
    <SensitiveStoryModal
      {...sensitiveStoryModal}
      isShowAlwaysChecked={isShowAlwaysChecked}
      changeAlwaysShowSetting={changeAlwaysShowSetting}
      onClickOk={onClickOk}
      onClickCancel={onClickCancel}
      isAnonymous={session?.isAnonymous}
    />
  );
};
